import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[cardFooter]',
  standalone: true
})
export class CardFooterDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
